'use strict';

angular.module('AcaApp').factory('ParticipantService',
[
  'ParticipantResource',
  function(ParticipantResource){
    return{
      addParticipant: function(participant, flag){
        var rpcConfig = {method: 'Save', params: [participant, flag]};
        return ParticipantResource.executeRpc(rpcConfig).$promise;
      },
      maskTin: function(tin){
        if(tin !== undefined){
          tin = this.removeSuffixOnTin(tin);
          if(tin.length === 9){
            return '*****' + tin.slice(-4);
          }
        }
        return tin;
      },
      removeSuffixOnTin: function(tin){
        return tin.split(' ')[0];
      },
      addExtraItemsOnParticipant: function(participant){
        var particiantObject = this;
        _.each(participant, function(item){
          _.extend(item, {
            tinWithMask: particiantObject.maskTin(item.tin),
            tinWithoutSuffix: particiantObject.removeSuffixOnTin(item.tin)
          });
        });
        return participant;
      },
      searchParticipantsByTin: function(tin){
        var rpcConfig = {method: 'SearchParticipantsByTin', params: [tin]};
        return ParticipantResource.executeRpc(rpcConfig).$promise;
      },
      searchParticipantsByAccount: function(tin){
        var rpcConfig = {method: 'SearchParticipantsByAccount', params: [tin]};
        return ParticipantResource.executeRpc(rpcConfig).$promise;
      },
      getParticipantRecords: function(){
        var rpcConfig = {method: 'GetParticipantRecords', params: []};
        return ParticipantResource.executeRpc(rpcConfig).$promise;
      },
      getFixParticipantRecords: function(){
        var rpcConfig = {method: 'GetFixParticipantRecords', params: []};
        return ParticipantResource.executeRpc(rpcConfig).$promise;
      },
      getParticipantByModRecno: function(modrecno){
        var rpcConfig = {method: 'GetParticipantByModRecno', params: [modrecno]};
        return ParticipantResource.executeRpc(rpcConfig).$promise;
      },
      Update: function(participant, flag, correctForm, includeAcctMembers){
        var rpcConfig = {method: 'Update', params: [participant,flag,correctForm, includeAcctMembers]};
        return ParticipantResource.executeRpc(rpcConfig).$promise;
      },
      getForms: function(modrecno){
        var rpcConfig = {method: 'GetFormsByModrecno', params: [modrecno]};
        return ParticipantResource.executeRpc(rpcConfig).$promise;
      },
      SearchParticipantRecords: function(search){
        var rpcConfig = {method: 'SearchParticipantRecords', params: [search]};
        return ParticipantResource.executeRpc(rpcConfig).$promise;
      },
      Delete: function(participant){
        var rpcConfig = {method: 'Delete', params: [participant]};
        return ParticipantResource.executeRpc(rpcConfig).$promise;
      }
    };
  }
]);